import { useState } from "react";
import { Dialog, Image, Portal, CloseButton } from "@chakra-ui/react";

const ImageComponent = ({ src, alt = "Image", imageProps = {}, backdrop = "white" }) => {
    const [scale, setScale] = useState(1);

    const handleWheel = (event) => {
        event.preventDefault();
        setScale((prev) => Math.min(Math.max(prev + event.deltaY * -0.01, 0.5), 3));
    };

    return (
        <Dialog.Root
            size="full"
            onOpenChange={(details) => {
                if (!details.open) {
                    setScale(1);
                }
            }}
        >
            <Dialog.Trigger asChild>
                <Image
                    src={src}
                    alt={alt}
                    cursor="zoom-in"
                    _hover={{ opacity: 0.85 }}
                    {...imageProps}
                />
            </Dialog.Trigger>

            <Portal>
                <Dialog.Backdrop bg={backdrop} />
                <Dialog.Positioner>
                    <Dialog.Content bg="transparent" shadow="none">
                        <Dialog.CloseTrigger asChild>
                            <CloseButton size="lg" />
                        </Dialog.CloseTrigger>

                        <Dialog.Body
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            h="full"
                            p={0}
                        >
                            <Image
                                src={src}
                                alt={alt}
                                objectFit="contain"
                                maxH="100vh"
                                maxW="100vw"
                                onWheel={handleWheel}
                                style={{ transform: `scale(${scale})`, transformOrigin: "center center" }}
                            />
                        </Dialog.Body>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    );
};

export default ImageComponent;